import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";
import { ModuleDefinition } from "../../model/module/types/module-definition/ModuleDefinition";

const moduleState = (state: RootState) => state.module;

const selectSelectedModuleDefinition = createSelector(
  moduleState,
  (state) => state.selectedModuleDefinition,
);

//

const selectAllModuleDefinitions = createSelector(
  moduleState,
  (state) => (state.moduleDefinitions || []) as ModuleDefinition[],
);

const selectModuleDefinitionsLoading = createSelector(
  moduleState,
  (state) => state.moduleDefinitionsLoading,
);

const selectInstancesPage =
  createSelector(moduleState, (state) => state.instancesPage) || 1;

const selectInstancesPageSize =
  createSelector(moduleState, (state) => state.instancesPageSize) || 10;

const selectInstances = createSelector(
  moduleState,
  (state) => state.instances || [],
);

const selectInstancesLoading = createSelector(
  moduleState,
  (state) => state.instancesLoading,
);
const selectInstancesMeta = createSelector(
  moduleState,
  (state) => state.allInstancesMeta,
);

const selectModuleDefinitionById = createSelector(
  [moduleState, (_, moduleId: string) => moduleId],
  (state, moduleId) =>
    state.moduleDefinitions?.find?.(({ _id }) => _id === moduleId),
);

export const moduleSliceSelectors = {
  selectSelectedModuleDefinition,
  selectAllModuleDefinitions,
  selectModuleDefinitionsLoading,
  selectInstancesPage,
  selectInstancesPageSize,
  selectInstances,
  selectInstnacesLoading: selectInstancesLoading,
  selectInstancesMeta,
  selectModuleDefinitionById,
};
